import { useEffect, useState } from "react";
import VerticalDrawer from "../../../../components/drawers/VerticalDrawer"
import useModal from "../../../../hooks/useModal";
import useRwas from "../../../../hooks/useRwas";
import useCompany from "../../../../hooks/useCompany";
import toast from "react-hot-toast";
import { Button } from "@oc-labs/wt-storybook";

let profileFields = [
  { key: "given_name", label: "Given Name" },
  { key: "family_name", label: "Family Name"},
  { key: "email", label: "Email" },
  { key: "birthdate", label: "Birthday"},
  { key: "address", label: "Address" },
  { key: "city", label: "City" },
  { key: "country", label: "Country"},
  { key: "postalCode", label: "Postal Code"},
  { key: "phone_number", label: "Phone Number" },
  { key: "splashScreen", label: "Splash Screen" },
]

export default function RequirementsDrawer({ rwa, reloadRwa }) {
  const { close, isOpen } = useModal("requirements-drawer");
  const { activeCompany: company } = useCompany();
  const { updateRwa } = useRwas();
  const [requiredFields, setRequiredFields] = useState([]);
  
  const handleSaveRequirements = async () => {
    try {
      const updatedRwaData = {
        name: rwa?.name,
        type: rwa?.type,
        requirements: JSON.stringify(requiredFields),
      };

      await updateRwa(company?.id, rwa.id, updatedRwaData);

      reloadRwa && reloadRwa();
      toast.success("Requirements saved successfully");
      close();
    } catch (err) {
      console.error("Error saving requirements", err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      let profileRequiredFields;
      try { 
        profileRequiredFields = JSON.parse(rwa.requirements) || []  
      } catch (e) { 
        profileRequiredFields = []
      }
      setRequiredFields(profileRequiredFields)
    }
  }, [rwa, isOpen]);

   

  return (<VerticalDrawer name="requirements-drawer" title="Requirements">
    <div className="space-y-3">
      {profileFields.map((field) => {
        return (<div key={field.key} className="flex items-center justify-between py-2">
          <span className="text-gray-700">{field.label}</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={(requiredFields || []).find((rf) => rf === field?.key)}
              onChange={() => {
                
                  setRequiredFields(prev => {
                  if (prev.includes(field.key)) {
                    // remove it
                    return prev.filter(v => v !== field.key)
                  } else {
                    // add it
                    return [...prev, field.key]
                  }
                })
              }}
              className="sr-only peer"
            />
            <span
              className={`w-14 h-7 rounded-full transition-colors duration-300 ${
                (requiredFields || []).find((rf) => rf === field.key) ? "bg-blue-600" : "bg-gray-300"
              } peer-focus:ring-2 peer-focus:ring-blue-400 peer-focus:ring-offset-1`}
            ></span>
            <span
              className={`absolute left-1 top-1 w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-300 ease-in-out ${
                (requiredFields || []).find((rf) => rf === field.key) ? "translate-x-7" : "translate-x-0"
              }`}
            ></span>
          </label>
        </div>)
      })}
    </div>
    <div className="mt-6 flex justify-end">
      <Button
        type="primary"
        onClick={handleSaveRequirements}
        className="flex-1"
      >
        Configure
      </Button>
    </div>
  </VerticalDrawer>)
}